<template>
  <main-layout>
    <template
      slot="sidebar"
      v-if="isLoggedIn"
    >
      <site-sidebar
        :is-open="isMenuOpen"
        @close="isMenuOpen = false"
      />
    </template>
    <router-view
      slot="header"
      @sidebar="toggleMenu"
      :is-menu-open="isMenuOpen"
      name="header"
    />
    <router-view name="default" />
  </main-layout>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Client } from '@stomp/stompjs';
import { CONNECTIVITY_STATUSES } from '@/helpers';

import { mapGetters, mapActions } from 'vuex';
import MainLayout from '@/layouts/main.layout';
import SiteSidebar from '@/components/common/SiteSidebar/SiteSidebar.vue';
import ModalOffline from '@/components/modals/ModalOffline';

@Component({
  name: 'App',
  metaInfo: {
    title: 'Welcome',
    titleTemplate: '%s | Diamond Duels',
  },
  components: {
    MainLayout,
    SiteSidebar,
  },
  computed: mapGetters([
    'user',
    'isLoggedIn',
    'isProcessing',
    'activeDuelId',
    'activeGameId',
    'gameState',
    'stompConfig',
    'stompConfigExists',
    'stompClient',
    'stompConnect',
    'stompSubscriptions',
    'connection',
    'connectionModalInstance',
  ]),
  methods: mapActions([
    'initStomp',
    'closePredictions',
    'startPredictions',
    'postResults',
    'nextCompetition',
    'cancelResults',
    'endHalfInning',
    'getPredictionsTypes',
    'getGameState',
    'getGames',
    'subscribeActiveTopics',
    'unsubscribeActiveTopics',
    'deactivateStomp',
    'setOfflineModalInstance',
  ]),
  watch: {
    connection: {
      handler(val) {
        switch (val) {
          case CONNECTIVITY_STATUSES.OFFLINE:
          case CONNECTIVITY_STATUSES.UNREACHABLE:
            const dialog = this.$q.dialog({
              component: ModalOffline,
              root: this.$root,
            });
            this.setOfflineModalInstance(dialog);
            break;
          case CONNECTIVITY_STATUSES.ONLINE:
            if (this.connectionModalInstance) {
              this.connectionModalInstance.hide();
            }
            this.setOfflineModalInstance(null);
        }
      },
      immediate: true,
    },
    async isLoggedIn(val) {
      if (val) {
        await this.init();
      } else {
        this.toggleMenu(false);
        this.destroyStomp();
      }
    },
    isProcessing: {
      handler(val) {
        this.$q.loading[val ? 'show' : 'hide']();
      },
      immediate: true,
    },
    stompConfigExists(val) {
      if (val) {
        this.initStomp(this.stompConfig);
      } else {
        console.log('STOMP CONFIG DELETED');
      }
    },
    activeDuelId: {
      handler(val, prevVal) {
        if (val) {
          this.subscribeActiveTopics(this.stompConfig);
        } else {
          this.unsubscribeActiveTopics();
        }
      },
    },
  },
})
export default class App extends Vue {
  // !DATA
  isMenuOpen = false;

  // !HOOKS
  async created() {
    if (!this.isLoggedIn) return;
    await this.init();
  }

  // !METHODS
  async init() {
    try {
      await Promise.all([this.getPredictionsTypes(), this.getGames()]);
      if (this.stompConfigExists) {
        this.initStomp(this.stompConfig);
      }
    } catch (err) {
      console.log(err);
    }
  }
  toggleMenu(state) {
    this.isMenuOpen = typeof state === 'boolean' ? state : !this.isMenuOpen;
  }

  destroyStomp() {
    if (this.stompClient) {
      this.deactivateStomp();
    }
  }

  activateStomp() {
    if (this.stompClient) {
      this.stompClient.activate();
    } else {
      this.initStomp(this.stompConfig);
    }
  }
}
</script>
